import ContactPageInfoBlock from './InfoBlock';

export default ContactPageInfoBlock;
